import { useState } from 'react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false); // close menu on mobile
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-white text-gray-900 shadow z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-between h-16">

        {/* Logo */}
        <div className="flex items-center space-x-2 cursor-pointer" onClick={() => scrollToSection('top')}>
          <img src="/Logo-NISHAR.jpg" alt="Nishar Hardware" className="h-10 w-10 rounded-full shadow-sm" />
          <span className="font-bold text-xl tracking-tight">Nishar Hardware</span>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex space-x-6">
          {['Home', 'Contact', 'About Us', 'Products'].map((label, index) => {
            const id = label.toLowerCase().replace(/\s+/g, '');
            return (
              <button
                key={index}
                onClick={() => scrollToSection(id)}
                className="relative group transition-colors duration-300 font-medium"
              >
                <span className="text-gray-700 group-hover:text-black transition">{label}</span>
                <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-black group-hover:w-full transition-all duration-300 ease-in-out"></span>
              </button>
            );
          })}
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            <svg className="h-6 w-6 text-gray-800" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white px-4 pb-4 space-y-2 text-gray-900">
          {['Home', 'Contact', 'About Us', 'Products'].map((label, index) => {
            const id = label.toLowerCase().replace(/\s+/g, '');
            return (
              <button
                key={index}
                onClick={() => scrollToSection(id)}
                className="block w-full text-left py-2 border-b border-gray-200 hover:text-black"
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
    </nav>
  );
}
